import { API_BASE_URL } from '../config';
import { MasterOption } from './masterData';

export type DenshijitiOption = {
  code: string;
  pref_name: string;
  city_name: string;
  pref_kana: string;
  city_kana: string;
  is_visible?: boolean;
  deleted_at?: string | null;
}

export type DenshijitiResponse = {
  data: DenshijitiOption[];
  success: boolean;
  message?: string;
}

// 地方自治体データの取得
export const fetchDenshijitiMaster = async (): Promise<DenshijitiOption[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/master/denshijiti`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('地方自治体データの取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('地方自治体データの取得エラー:', error);
    throw error;
  }
};

// 都道府県のみの取得（市区町村なし）
export const fetchDenshijitiOptions = async (): Promise<MasterOption[]> => {
  try {
    // const allData = await fetchDenshijitiMaster();
    // console.log('allData : ', allData);
    // // 市区町村名が空のもの（都道府県のみ）をフィルタリング
    // return allData.map(item => ({
    //   value: item.code,
    //   label: item.pref_name,
    // }));
    // return allData;
    const response = await fetch(`${API_BASE_URL}/v1/master/denshijiti`, {
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'Accept-Charset': 'utf-8'
      }
    });
    
    if (!response.ok) {
      throw new Error('地方自治体データの取得に失敗しました');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('都道府県データの取得エラー:', error);
    throw error;
  }
};

// 都道府県のみの取得（市区町村なし）
export const fetchPrefectureOptions = async (): Promise<MasterOption[]> => {
  try {
    const allData = await fetchDenshijitiMaster();
    // 市区町村名が空のもの（都道府県のみ）をフィルタリング
    return allData.filter(item => !item.city_name || item.city_name === '').map(item => ({
      value: item.code,
      label: item.pref_name,
    }));
  } catch (error) {
    console.error('都道府県データの取得エラー:', error);
    throw error;
  }
};

// 特定の都道府県の市区町村を取得
export const fetchCityOptionsByPrefecture = async (prefCode: string): Promise<MasterOption[]> => {
  try {
    const allData = await fetchDenshijitiMaster();
    // 指定された都道府県コードで始まり、市区町村名があるものをフィルタリング
    return allData.filter(item => 
      item.code.startsWith(prefCode) && 
      item.city_name && 
      item.city_name !== ''
    ).map(item => ({
      value: item.code,
      label: item.city_name,
    }));
  } catch (error) {
    console.error('市区町村データの取得エラー:', error);
    throw error;
  }
};
